import { render, staticRenderFns } from "./my-icon.vue?vue&type=template&id=04603707&scoped=true&"
import script from "./my-icon.vue?vue&type=script&lang=js&"
export * from "./my-icon.vue?vue&type=script&lang=js&"
import style0 from "./my-icon.vue?vue&type=style&index=0&id=04603707&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04603707",
  null
  
)

export default component.exports